import React from 'react';
import type CustomFieldDetail from '@atlassian/jira-spa-apps-admin-pages-performance-custom-field/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyCustomFieldDetail = lazyForPaint<typeof CustomFieldDetail>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-custom-field" */ '@atlassian/jira-spa-apps-admin-pages-performance-custom-field'
		),
	),
);

export const CustomFieldMetricDetail = () => (
	<LazyPage
		Page={LazyCustomFieldDetail}
		pageId="system-performance-metric-detail-custom-field"
		shouldShowSpinner
	/>
);
